import * as React from "react";
import { Loader2, X } from "lucide-react";
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "../../shadcn/components/ui/Avatar";
import { Button } from "../../shadcn/components/ui/Button";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../shadcn/components/ui/Card";
import { Textarea } from "../../shadcn/components/ui/Textarea";
import avatar from "../../assets/serviceProvider dashboard/messages/avatar2.png";
import { useState } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import { useEffect } from "react";

export function TicketThread({ ticketId, onClose }) {
  const messages = [
    {
      id: "1",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna",
      sender: {
        name: "Admin",
        avatar: avatar,
        isAdmin: true,
      },
      response:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna",
    },
    {
      id: "2",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna",
      sender: {
        name: "Admin",
        avatar: avatar,
        isAdmin: true,
      },
      response:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna",
    },
  ];

  const [ticketDetails, setTicketDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [commentText, setCommentText] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loadingTicket, setLoadingTicket] = useState(true);

  // Function to submit the comment
  const handleCommentSubmit = async () => {
    if (!commentText.trim()) return;
    setIsSubmitting(true);

    const token = localStorage.getItem("authToken");

    try {
      const response = await axios.post(
        "https://silver-tlc-backend-delta.vercel.app/api/v1/ticket/sendcomment",
        {
          token: token,
          ticket_id: ticketDetails._id,
          textMessage: commentText,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        toast.success("Comment submitted successfully!");
        setCommentText(""); // Clear input field

        // Refresh the ticket details
        await fetchTicketDetails(ticketDetails._id);
      } else {
        throw new Error("Failed to submit comment");
      }
    } catch (error) {
      console.error("Error submitting comment:", error);
      toast.error(
        error.response?.data?.message ||
          "An error occurred while submitting the comment."
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  // Fetch specific ticket details
  const fetchTicketDetails = async (ticketId) => {
    setLoadingTicket(true);
    const token = localStorage.getItem("authToken");

    try {
      const response = await axios.post(
        "https://silver-tlc-backend-delta.vercel.app/api/v1/ticket/get-specificticket",
        {
          token: token,
          ticket_id: ticketId,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        setTicketDetails(response.data.ticketData);
      } else {
        throw new Error("Failed to fetch ticket details");
      }
    } catch (error) {
      console.error("Error fetching ticket details:", error);
      toast.error(
        error.response?.data?.message ||
          "An error occurred while fetching ticket details."
      );
    } finally {
      setLoadingTicket(false);
    }
  };

  useEffect(() => {
    console.log("Ticket ID:", ticketId); // Check if ticketId is coming through

    if (ticketId) {
      // Only call the API if ticketId is not null
      fetchTicketDetails(ticketId);
    }
  }, [ticketId]);

  return (
    <Card className="max-w-3xl mx-auto lg:h-[80vh] h-[30rem] overflow-y-scroll">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-4">
        <div className="space-y-1">
          <CardTitle className="truncate">
            {ticketDetails?.description || "loading..."}
          </CardTitle>
          <p className="text-sm text-muted-foreground">
            Ticket Name: {ticketDetails?.name} | Status:{" "}
            {ticketDetails?.status || "NA"}
          </p>
        </div>
        <Button variant="ghost" size="icon" onClick={onClose}>
          <X className="h-4 w-4" />
          <span className="sr-only">Close</span>
        </Button>
      </CardHeader>

      <CardContent className="space-y-6">
        {/* Messages Thread */}
        <div className="space-y-6">
          {loadingTicket ? (
            <Loader2 className="animate-spin" />
          ) : (
            ticketDetails?.ticketComments?.map((comment) => (
              <div key={comment._id} className="space-y-4">
                {/* Comment Block */}
                <div className="flex gap-4">
                  <Avatar>
                    <AvatarFallback>
                      {comment.sender.charAt(0).toUpperCase()}
                    </AvatarFallback>
                  </Avatar>
                  <div className="flex-1 space-y-1">
                    <p className="text-sm font-medium">{comment.sender}</p>
                    <div className="rounded-lg bg-gray-100 p-4">
                      <p className="text-sm leading-relaxed text-gray-700">
                        {comment.textMessage}
                      </p>
                      <span className="text-xs text-gray-500">
                        {new Date(comment.date).toLocaleString()}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>

        {/* Comment Section */}
        <div className="space-y-4">
          <h3 className="text-sm font-medium">Comment</h3>
          <Textarea
            placeholder="Write your comment here"
            className="min-h-[100px]"
            value={commentText}
            onChange={(e) => setCommentText(e.target.value)}
            disabled={isSubmitting} // Disable while submitting
          />
          <Button
            className="w-full bg-purple-600 hover:bg-purple-700"
            onClick={handleCommentSubmit}
            disabled={isSubmitting} // Disable while submitting
          >
            {isSubmitting ? "Submitting..." : "Submit"}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
